import { BookingAction } from '../../constants';

const formatBookingStatus = (tripStatus) => {
  if (tripStatus === BookingAction.BOOK) return 'Booked';
  if (tripStatus === BookingAction.HOLD) return 'On hold';
  if (tripStatus === BookingAction.CANCELLED) return 'Canceled';
  if (tripStatus === BookingAction.BROCHURE) return 'Brochure';
  if (tripStatus === BookingAction.COMPARE) return 'Compare';
  if (tripStatus === BookingAction.SEND_QUOTE) return 'Email Quote Sent';
  if (tripStatus === BookingAction.ADVICE) return 'Sent for advice';
  if (tripStatus === BookingAction.REQUEST_TO_BOOK) return 'Pending Trip Approval';
  if (tripStatus === undefined || tripStatus === null) return 'Failed';
  return '';
};

export default formatBookingStatus;
